import { createSelector } from 'reselect'
import cartSelector from './cartSelector'

const cartNameSelector = createSelector(
    cartSelector,
    (cart): string => cart.cartName,
)

export default cartNameSelector
